import styled from "styled-components";
import { Box } from "@mui/material";
import theme from "../../../../styles/theme";

export const TileContainer = styled(Box)<{ $selected: boolean }>`
  && {
    width: 280px; /* Largura reduzida */
    padding: 16px; /* Padding menor */
    border: 2px solid ${(props) => (props.$selected ? "#4285F4" : "#E0E0E0")};
    border-radius: 12px;
    cursor: pointer;
    background-color: ${(props) => (props.$selected ? "#F3F8FF" : "#FFFFFF")};
    transition: all 0.2s ease-in-out;
    box-shadow: ${(props) =>
      props.$selected
        ? "0 4px 12px rgba(66, 133, 244, 0.2)"
        : "0 2px 4px rgba(0, 0, 0, 0.05)"};

    &:hover {
      border-color: #4285f4;
      box-shadow: 0 4px 12px rgba(66, 133, 244, 0.15);
    }

    .header {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 12px;
    }

    .icon-wrapper {
      color: #4285f4;
    }

    .label {
      font-family: "Roboto", sans-serif;
      font-weight: 700;
      font-size: 16px; /* Fonte um pouco menor */
      color: #202124;
    }

    .address-details {
      font-family: "Roboto", sans-serif;
      font-size: 13px; /* Fonte menor para o endereço */
      color: #5f6368;
      line-height: 1.5;
      display: flex;
      flex-direction: column;
      gap: 4px; /* Espaçamento entre as linhas do endereço */
    }
  }
`;

export const Tile = styled.button<{ $selected: boolean; $disabled: boolean }>`
  font-family: "Roboto", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 320px;
  height: 170px;
  padding: 16px;
  border-radius: 12px;
  border: 2px solid
    ${(p) => (p.$selected ? "#4285F4" : "rgba(0,0,0,0.08)")};
  background: ${(p) => (p.$selected ? "#F5F8FF" : "#FFFFFF")};
  box-shadow: ${(p) =>
    p.$selected ? "0 0 0 3px rgba(66, 133, 244, 0.15)" : "none"};
  cursor: ${(p) => (p.$disabled ? "not-allowed" : "pointer")};
  outline: none;
  transition: border-color 0.2s ease, background-color 0.2s ease,
    box-shadow 0.2s ease, transform 0.05s ease;

  &:hover {
    border-color: ${(p) => (p.$selected ? "#4285F4" : "#C7D7FE")};
    box-shadow: ${(p) =>
      p.$selected ? "0 0 0 3px rgba(66, 133, 244, 0.15)" : "0 2px 8px rgba(0,0,0,0.06)"};
  }

  &:active {
    transform: scale(0.995);
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.25);
  }

  &:disabled {
    opacity: 0.6;
  }
`;

export const IconCircle = styled.div<{ $selected: boolean }>`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  margin-bottom: 14px;

  background: ${(p) => (p.$selected ? theme.colors.blue.primary : "#F1F3F4")};
  color: ${(p) => (p.$selected ? "#FFFFFF" : "#9AA0A6")};

  & > svg {
    font-size: 32px;
  }
`;

export const Label = styled.span`
  color: #1f2937;
  font-weight: 600;
  font-size: 18px;
`;